<template>
    <ProductCard
        :product-id="productData.id"
        product-type="parking"
        :product-location-type="airportData.content.type"
        :product-image="optimizedImage"
        :product-link="productLink"
        :product-name="productData.name"
        :product-rating="productData.ratings.rating"
        :product-rating-count="productData.ratings.rating_count"
        :product-distance="productData.distance"
        :airport-code="airportData.content?.code"
        :product-shuttle-option="productData.shuttle_option"
        :product-options="productData.options"
        :product-stars-rating="productData.ratings.rating"
        :product-shuttle-free-only="true"
        card-type="ParkingProductCard"
    />
</template>

<script setup lang="ts">
import ProductCard from '../cards/ProductCard.vue';

const { blok, productData, airportData } = defineProps<{
    blok: any;
    productData: any;
    airportData: any;
}>();

const productLink = computed(() =>
    productData.content.psf_url ? relativeLink(productData.content.psf_url).trim() : '/' + productData.content.slug
);

const img = useImage();
const optimizedImage = computed(() => {
    const imgUrl = img(productData.media?.logo, { format: 'webp', height: 200 });
    return imgUrl;
});

function relativeLink(link: string) {
    const fullUrl = new URL(link);
    return fullUrl.pathname;
}
</script>

<style lang="postcss" scoped></style>
